import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, useLocalizeMessage, useDateTimeFormat } from 'libs.nucleus';
export const VisitStatusBadge = ({ visitEvent }) => {
    const translate = useLocalizeMessage();
    const { formatDateTime } = useDateTimeFormat();
    switch (true) {
        case !!visitEvent?.c_started:
            return (_jsx(Badge, { "data-testid": 'visit-status-badge', label: formatDateTime(visitEvent?.c_started, { dateOnly: true }) }));
        case !!visitEvent?.c_skipped_date:
            return (_jsx(Badge, { variant: 'incomplete', "data-testid": 'visit-status-badge', label: `${translate('generic.skipped')} - ${formatDateTime(visitEvent?.c_skipped_date, { dateOnly: true })}` }));
        default:
            return null;
    }
};
